import { Component, Input, OnChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, withLatestFrom } from 'rxjs/operators';

import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { candidateExternalUrl, jobExternalUrl, } from '@core/settings/license-configuration';
import { isTruthy } from '@shared/utils';

import { AtsButtonType } from './ats-button.type';

@Component({
  selector: 'mojo-ats-button',
  templateUrl: './ats-button.component.html',
  styleUrls: ['./ats-button.component.scss'],
})
export class AtsButtonComponent implements OnChanges {
  @Input()
  type: AtsButtonType;
  @Input()
  entity: { externalId: string; externalDisplayId: string };
  @Input()
  mini = false;

  greenhouseAts = AppFeatureExtensions.GREENHOUSE_ATS;
  oracleAts = AppFeatureExtensions.ORACLE_ATS;

  private oracle = 'oracle';
  private greenhouse = 'greenhouse';

  externalUrl$: Observable<string>;

  ngOnChanges(): void {
    if (AtsButtonType.JOB === this.type) {
      this.externalUrl$ = this.store.select(jobExternalUrl)
        .pipe(
          filter(isTruthy),
          map((externalUrl) =>
            externalUrl?.replace('__JOB_ID__', this.entity.externalId),
          ),
        );
    }
    if (AtsButtonType.CANDIDATE === this.type) {
      this.externalUrl$ = this.store.select(candidateExternalUrl)
        .pipe(
          withLatestFrom(this.getAts$),
          map(([externalUrl, ats]) =>
            externalUrl?.replace(
              '__CANDIDATE_ID__',
              ats === this.oracle
                ? this.entity.externalDisplayId
                : this.entity.externalId,
            ),
          ),
        );
    }
  }

  supported$ = this.featureExtensionsService.hasAnyFeatureExtensions([
    this.greenhouseAts,
    this.oracleAts,
  ]);

  getAts$ = this.featureExtensionsService.licenseFeatureExtensions$.pipe(
    map((extensions: string[]) => {
      if (extensions.includes(this.greenhouseAts)) {
        return this.greenhouse;
      }
      if (extensions.includes(this.oracleAts)) {
        return this.oracle;
      }
    }),
    shareReplay(1),
  );

  constructor(
    private store: Store,
    private featureExtensionsService: MojoFeatureExtensionsService,
  ) { }
}
